import dayjs from 'dayjs';

import type { Task } from '@webapp/account/src/resources/tasks/task';

export interface TasksState {
    lastUpdate: number;
    waiting: Record<string, number>;
    tasks: { [key in string]: Task };
}

export const initialState: Readonly<TasksState> = {
    lastUpdate: dayjs().unix(),
    waiting: {},
    tasks: {},
};
